import request from '@/utils/request'
import { formatParam } from '@/utils/tool'

// 获取产品类型，并且仅返回产品类型对应在全球货仓存在产品的数据
export function custProductTypies (params?: {
  areaId: string | number,
  keyword: string
}): any {
  return request(`/saas/gtpw/product/custProductTypies?${formatParam(params)}`, {
    method: 'GET'
  })
}

interface cityTypes {
  dbLink?: string;
  keyword?: string;
  parentId: string | number;
  parentMchId?: string;
  treeId?: string;
}
// 根据aearId获取该区域对应的下级区域信息
export function city (params: cityTypes): any {
  return request(`/saas/gtpw/product/city?${formatParam(params)}`)
}

// 获取产品类型，并且仅返回产品类型对应在全球货仓存在产品的数据
export function mchUserLogo (params: {
  autoCount?: boolean;
  page?: number | string;
  parentMchId: number;
  resultNum?: number;
  sort?: string;
  startIndex?: number;
}): any {
  return request(`/saas/gtpw/mchUser/logo?${formatParam(params)}`)
}

// 获取所有币种信息--不获取当前用户的币种
export function currenties (): any {
  return request('/saas/gtpw/transaction/currenties', {
    method: 'GET'
  })
}

// 显示商户资料+评分  获取其他商户信息
export function getMchUserInfo (dbLink: string | number, parentMchId: string | number): any {
  return request(`/saas/gtpw/mchUser/info/${dbLink}/${parentMchId}`)
}

//  -------------------------    站内信   ---------  start  ----------------
// 获取站内信各状态数量
export function countLetters (): any {
  return request('/saas/gtpw/siteMailLog/countState', {
    method: 'GET'
  })
}

// 删除站内信
export function deleteLetters (params): any {
  return request(`/saas/gtpw/siteMailLog/delete?${formatParam(params)}`, {
    method: 'DELETE'
  })
}

// 获取站内信列表
export function listLetters (params): any {
  const req1 = request(`/saas/gtpw/siteMailLog/list?${formatParam(params)}`)

  const req2 = request(`/saas/gtpw/siteMailLog/list?${formatParam({
    autoCount: 1,
    ...params
  })}`)
  return new Promise((resolve, reject) => {
    Promise.all([req1, req2])
      .then((result) => {
        resolve({
          ...result[0],
          sizeAll: result[1].sizeAll
        })
      }).catch(err => {
        reject(err)
      })
  })
  // return request(`/saas/gtpw/siteMailLog/list?${formatParam(params)}`)
}

// 加载站内信详情
export function loadLetters (): any {
  return request('/saas/gtpw/siteMailLog/load', {
    method: 'GET'
  })
}

// 标记已读
export function markReadLetters (params): any {
  return request(`/saas/gtpw/siteMailLog/markRead?${formatParam(params)}`, {
    method: 'PUT'
  })
}

// /openapi/enum/typeSiteMail站内信通知类型
export function typeSiteMail () {
  return request('/openapi/enum/typeSiteMail', {
    method: 'GET'
  })
}

//  -------------------------    站内信   ---------  end  ----------------

// 字母城市获取
export function letterCities (params: {
  // parentMchId: string | number;
  treeId?: string;
  areaId: number
}): any {
  return request(`/saas/gtpw/product/letterCities?${formatParam(params)}`, {
    method: 'GET'
  })
}

// 获取交易商户列表（数据最大返回200个商户）
export function findTradingMerchantList (params): any {
  return request(`saas/gtpw/transaction/findTradingMerchantList?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 资金变动列表
export function fundChangeList (params): any {
  return request(`/saas/gtpw/transaction/fundChangeList?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 资金变动列表导出
export function fundChangeListExport (params): any {
  return request(`/saas/gtpw/transaction/fundChangeListExport?${formatParam(params)}`, {
    method: 'GET',
    responseType: 'blob',
    timeout: 30000
  })
}

type noticeType = 1
// 添加订阅通知信息
export function addMchNotice (params: {
  accountBalance: string, // 账户余额
  mchId: string | number, // 商户ID
  noticePhone: string, // 通知手机号
  noticeType: noticeType[] // 类型(目前只有 余额类型 后续可能会增加)   余额 1
}): any {
  return request('/saas/gtpw/smsnotice/addMchNotice', {
    method: 'POST',
    data: params
  })
}

// 根据mchId获取订阅通知信息
export function getMchNotice (mchId: number | string): any {
  return request(`/saas/gtpw/smsnotice/getMchNotice/${mchId}`, {
    method: 'GET'
  })
}
